var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPencilLine = function SvgPencilLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 15 15"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M13.666 13.5H8.333m-7 .333 3.7-1.422c.236-.091.354-.137.465-.196q.147-.08.28-.183c.1-.077.19-.166.369-.345l7.52-7.52A1.886 1.886 0 0 0 11 1.5L3.48 9.02a4 4 0 0 0-.346.368 2 2 0 0 0-.182.28c-.06.11-.105.23-.196.466zm0 0 1.372-3.567c.098-.255.147-.383.232-.441a.33.33 0 0 1 .252-.054c.1.02.198.116.391.31l1.506 1.505c.193.194.29.29.31.391a.33.33 0 0 1-.054.253c-.059.084-.186.133-.442.231z"
  })));
};
export default SvgPencilLine;